module.exports = __webpack_public_path__ + "static/media/arrow_next.9e1e17fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/arrow_next.svg
// module id = 272
// module chunks = 0